import React from 'react';

import {Helpers} from '../../core/src/helpers';
import { withError } from '../../shared/components/error-boundary';
import withWindowResize from '../../ui/components/window-resize';
import VideoContent from '../../custom-content/components/video-content';

import './add-to-cart.less';

const FooterBanner = ({footer, device,  customBannerClick}) => {
	let { footerVideoLink, footerVideoImage, footerVideoMobileImage, footerVideoText, bannerHtml, videoType='YouTube' } = footer;
	let imagePlaceholder = device === 'desktop' ? footerVideoImage : footerVideoMobileImage;
	
    if(bannerHtml){
    	return (
    		<div className="pg-custom-footer-banner" 
    			 onClick={customBannerClick} 
    			 dangerouslySetInnerHTML={Helpers.createMarkup(bannerHtml)}>
			</div>);
    }

	return (
			<VideoContent 
		     	playMode={'modal'}
		     	type={videoType}
		     	videoUrl={footerVideoLink}
		     	bannerText={footerVideoText}
		     	imagePlaceHolderUrl={imagePlaceholder}/>
	);
};


export default  withError(withWindowResize(FooterBanner));